import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import '@angular/compiler';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { LicenseManager } from "ag-grid-enterprise";
import * as echarts from 'echarts';

// Set AG Grid Enterprise license key
LicenseManager.setLicenseKey(
  'Arkin_HIS_3Devs28_March_2020__MTU4NTM1MzYwMDAwMA==ce1eed0a6018afcf2a06b081b503f06a'
);

echarts.registerTheme('customTheme', {
  title: {
    textStyle: {
      color: 'white',
    },
  },
  color: [
    '#fffdcf', '#ff7070', '#d4fc88', '#ff63fe', '#ffb026', '#ffc5ab',
    '#c2da46', '#ff825b', '#ff6188', '#cfa07c', '#a3d67e', '#ffe10f',
    '#d9b6cd', '#ffe278', '#80ffc6',
  ],
  xAxis: {
    axisLabel: {
      color: 'white',
    },
  },
  yAxis: {
    axisLabel: {
      color: 'white',
    },
  },
  tooltip: {
    backgroundColor: '#333',
    textStyle: {
      color: '#fff',
    },
  },
});

// Enable production mode
if (environment.production) {
  enableProdMode();
}

// Bootstrap the Angular application
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
